import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { InaSchoolEnrollment, InaSchoolEnrollmentSelection } from '../model/ina-school-enrollment-sections';
import { TrackingHistory, TrackingHistories } from './history';

@Injectable({
  providedIn: 'root'
})
export class InaService extends BaseRestApiService {

  private inaSelectionSubject=new BehaviorSubject(new InaSchoolEnrollmentSelection())
  inaSelectionSubject$=this.inaSelectionSubject.asObservable();

  private inaHistorySelectionSubject=new BehaviorSubject(new TrackingHistories())
  inaHistorySelectionSubject$=this.inaHistorySelectionSubject.asObservable();

  constructor(http: HttpClient, urlProvider: UrlProviderService) {
    super(http, urlProvider);
  }

  setCurrentInaHistorySelectionObject(trackingHistories:TrackingHistories){    
    this.inaHistorySelectionSubject.next(trackingHistories)
  }

  setCurrentInaSelectionObject(inaSel:InaSchoolEnrollmentSelection){    
    this.inaSelectionSubject.next(inaSel)
  }
  
  resetCurrentInaSelectionObject(){this.setCurrentInaSelectionObject(new InaSchoolEnrollmentSelection());}


  getINAHistory(urlParam: string) {
    return this.get<any>(EndPoints.get_INA_History, undefined,urlParam);
  }

  getINA(urlParam:string):Observable<any>
  {
    return this.get<any>(EndPoints.get_INA_SchoolEnrollments, undefined,urlParam);
  }

  updateINA(inaschoolenroll:InaSchoolEnrollment):Observable<any>{
    let tempObject ={'dv': inaschoolenroll};

    return this.put<any>(EndPoints.update_INA,'',null,false,tempObject);
  }
  createINA(param:any):Observable<any> {
    
    return this.post<any>(EndPoints.create_INA,false,'',{
      dv:param
    });
  }  

  createINAHistory(lstHistoryTracking:any):Observable<any> {
    return this.post<any>(EndPoints.create_INA_History,false,'',{lstHistoryTracking});
  }

  getINAStatus():Observable<number>{
    return this.inaSelectionSubject$.pipe(
      switchMap((x) => {
        return of(x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId);
      })
    );    
  }
}
